var _desc, _defs, _rect, _g, _text, _text2, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicroservices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 960 540",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Spring Boot microservice architecture") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "A Spring Boot microservice architecture diagram with API gateway, Eureka discovery, services, and Docker.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#172554"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#111827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#422006"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "line",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#60a5fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f97316"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "arrow",
    markerWidth: 10,
    markerHeight: 10,
    refX: 7,
    refY: 3,
    orient: "auto",
    markerUnits: "strokeWidth"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L9,3 z",
    fill: "#93c5fd"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 960,
    height: 540,
    fill: "url(#bg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    stroke: "#cbd5e1",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120 96H840M120 174H840M120 252H840M120 330H840M120 408H840"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 70V464M280 70V464M400 70V464M520 70V464M640 70V464M760 70V464"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 86,
    fill: "#e0f2fe",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 28,
    fontWeight: 900
  }, "Microservice Architecture")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 116,
    fill: "#cbd5e1",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 16
  }, "Spring Boot, Eureka, REST API, Docker")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "url(#line)",
    strokeWidth: 4,
    strokeLinecap: "round",
    markerEnd: "url(#arrow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210 264H338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474 264H604"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676 220L746 164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676 264H746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676 308L746 364"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450 218L530 158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450 310L530 386"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Inter, Arial, sans-serif"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(92 202)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 146,
    height: 124,
    rx: 24,
    fill: "#020617",
    fillOpacity: 0.76,
    stroke: "#60a5fa",
    strokeOpacity: 0.38
  }), /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 42,
    fill: "#bfdbfe",
    fontSize: 16,
    fontWeight: 800
  }, "Client"), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 62,
    width: 90,
    height: 14,
    rx: 7,
    fill: "#334155"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 88,
    width: 64,
    height: 14,
    rx: 7,
    fill: "#334155"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(338 190)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 148,
    rx: 24,
    fill: "#f8fafc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 102,
    height: 40,
    rx: 14,
    fill: "#dbeafe"
  }), /*#__PURE__*/React.createElement("text", {
    x: 31,
    y: 49,
    fill: "#1d4ed8",
    fontSize: 15,
    fontWeight: 900
  }, "Gateway"), /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 91,
    fill: "#334155",
    fontSize: 14,
    fontWeight: 700
  }, "Auth"), /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 118,
    fill: "#334155",
    fontSize: 14,
    fontWeight: 700
  }, "Routing")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(530 102)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 92,
    rx: 22,
    fill: "#0f172a",
    stroke: "#22c55e",
    strokeOpacity: 0.38
  }), /*#__PURE__*/React.createElement("text", {
    x: 25,
    y: 39,
    fill: "#bbf7d0",
    fontSize: 17,
    fontWeight: 900
  }, "Eureka"), /*#__PURE__*/React.createElement("text", {
    x: 25,
    y: 65,
    fill: "#cbd5e1",
    fontSize: 13,
    fontWeight: 700
  }, "Discovery")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(530 346)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 92,
    rx: 22,
    fill: "#0f172a",
    stroke: "#38bdf8",
    strokeOpacity: 0.38
  }), /*#__PURE__*/React.createElement("text", {
    x: 25,
    y: 39,
    fill: "#bae6fd",
    fontSize: 17,
    fontWeight: 900
  }, "Docker"), /*#__PURE__*/React.createElement("text", {
    x: 25,
    y: 65,
    fill: "#cbd5e1",
    fontSize: 13,
    fontWeight: 700
  }, "Containers")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(746 104)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 86,
    rx: 20,
    fill: "#020617",
    fillOpacity: 0.78,
    stroke: "#f97316",
    strokeOpacity: 0.45
  }), /*#__PURE__*/React.createElement("text", {
    x: 22,
    y: 38,
    fill: "#fed7aa",
    fontSize: 15,
    fontWeight: 900
  }, "User API"), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 55,
    width: 74,
    height: 10,
    rx: 5,
    fill: "#475569"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(746 220)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 86,
    rx: 20,
    fill: "#020617",
    fillOpacity: 0.78,
    stroke: "#f97316",
    strokeOpacity: 0.45
  }), /*#__PURE__*/React.createElement("text", {
    x: 22,
    y: 38,
    fill: "#fed7aa",
    fontSize: 15,
    fontWeight: 900
  }, "Exam API"), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 55,
    width: 74,
    height: 10,
    rx: 5,
    fill: "#475569"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(746 336)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 86,
    rx: 20,
    fill: "#020617",
    fillOpacity: 0.78,
    stroke: "#f97316",
    strokeOpacity: 0.45
  }), /*#__PURE__*/React.createElement("text", {
    x: 22,
    y: 38,
    fill: "#fed7aa",
    fontSize: 15,
    fontWeight: 900
  }, "Data API"), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 55,
    width: 74,
    height: 10,
    rx: 5,
    fill: "#475569"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicroservices);
export default __webpack_public_path__ + "static/media/microservices.e283379882d47b3de7322b5bc950d748.svg";
export { ForwardRef as ReactComponent };